export const PAGE_TURN_TIMER_MS = 5000